import type { ComputedRef } from 'vue';
import type { BasicPlayerEmit, BasicPlayerProps } from 'src/models/moviePlayer';
import type {
  useBasicPlayerState,
} from 'src/components/lib/MoviePlayer/BasicMoviePlayer/composables/useBasicPlayerState';
import type {
  useBasicPlayerPlayback,
} from 'src/components/lib/MoviePlayer/BasicMoviePlayer/composables/useBasicPlayerPlayback';
import {
  useMoviePlayerOrchestrationCore,
  type OrchestrationSubComposables,
} from 'src/components/lib/MoviePlayer/composables/useMoviePlayerOrchestrationCore';

type SubComposables = OrchestrationSubComposables<ReturnType<typeof useBasicPlayerPlayback>>;

type BasicPlayerContext = {
  compareModeTooltip: ComputedRef<string>;
  switchToCompareMode: () => void;
  closeMoviePlayer: () => void;
  shortcutKeyAction: (key: string) => void;
  onCurrentMovieListIdChangeBySelect: () => void;
};

// BasicMoviePlayer/index.vue側で構築済みのstate・sub composableを受け取り、
// watch/onMounted等のオーケストレーションをuseMoviePlayerOrchestrationCoreに委譲する。
// config はvjsPrepared対象vid一覧のみ注入する。
export function useBasicPlayer(
  props: BasicPlayerProps,
  emit: BasicPlayerEmit,
  playerState: ReturnType<typeof useBasicPlayerState>,
  sub: SubComposables,
): BasicPlayerContext {
  return useMoviePlayerOrchestrationCore(props, emit, playerState, sub, {
    vjsPreparedIds: () => [sub.playback.vid1, sub.playback.vid2, sub.playback.vid3],
  });
}
